import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function logsDescarregamentos(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@logsdescarregamentos/FIND_DATA':
      case '@logsdescarregamentos/UPDATE_DATA':
      case '@logsdescarregamentos/DELETE_DATA':
      case '@logsdescarregamentos/STORE_DATA': {
        draft.loading = true;
        break;
      }

      case '@logsdescarregamentos/SUCCESS_REMOVE':
      case '@logsdescarregamentos/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@logsdescarregamentos/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.data;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@logsdescarregamentos/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.data;
        break;
      }

      case '@logsdescarregamentos/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
